module.exports = __webpack_public_path__ + "static/video-banner-e904843f122c6c8afb806076be9e0760.png";